<template>
    <div class="bg-zinc-800 text-white p-4 sm:p-8 bg-cover bg-center bg-blend-overlay" :style="style">
        <div class="mb-3 sm:mb-4">Accept cookies to watch this {{ entity || 'video' }}.</div>
        <div class="flex flex-row space-x-3 pt-1">
            <button-primary buttonText="Enable Cookies" :buttonClick="acceptDefaultCookies"></button-primary>
            <button-primary
                buttonColor="bg-zinc-700 hover:bg-zinc-600 text-white"
                buttonText="Settings"
                buttonRoute="/cookies"
            ></button-primary>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'pinia';

export default {
    name: 'MissingVideo',
    props: {
        poster: {
            required: false,
            type: String,
            default: null,
        },
        entity: {
            required: false,
            type: String,
            default: null,
        },
    },
    computed: {
        style() {
            if (!this.poster) return {};
            return {
                backgroundImage: `url(${this.poster})`,
            };
        },
    },
    methods: {
        ...mapActions(useStoreCookies, {
            acceptDefaultCookies: 'acceptDefaultCookies',
        }),
    },
};
</script>
